import config from "../../common/config";

const loadKasada = () => {
  if (window && (!window.KPSDK || !window.KPSDK.isReady())) {
    const magentoDomain = config
      .getMagentoUrl()
      .replace("https://", "")
      .replace("/graphql", "");
    const url = `https://${magentoDomain}/149e9513-01fa-4fb0-aad4-566afd725d1b/2d206a39-8ed7-437e-a3be-862e0f06eea3/p.js`;
    document.addEventListener("kpsdk-load", () => {
      window.KPSDK.configure([
        {
          protocol: "https",
          method: "*",
          domain: magentoDomain,
          path: "/graphql",
        },
      ]);
    });

    const script = document.createElement("script");
    script.src = url;
    script.async = true;
    document.head.appendChild(script);
  }
};

export const loadBotDefence = () => {
  if (KASADA_ENABLED === "true") {
    loadKasada();
  }
};
